import React, { Component } from 'react';
import {SupplierLogger} from 'rest/services/SupplierLogger';
import { Panel } from 'widgets/default/panel';
import { PanelBody } from 'widgets/default/panel/body';
import Table from '../table/Table';
import TableBody from '../table/Body';
import { Header } from 'widgets/default/Header';

import { actions } from 'actions';
import { SupplierStore } from 'stores/SupplierStore';

import { Field } from './Field';
import { TextFieldEdit } from './TextFieldEdit';
import { CountryDropDown} from './CountryDropDown';
import { TimezoneDropDown} from './TimezoneDropDown';

class ContactWidget extends Component {
  state = {
    saved: false,
    fields: [],
  }

  componentWillMount() {
    const { supplier } = this.props;

    this.setState({
      fields: this.getFields(_.pick(supplier, _.keys(this.fieldDefaults))),
    });
  }

  fieldDefaults = {
    firstname: { title: "First name", changed: false, editComponent: TextFieldEdit, validator: function(value) {if(value != "") return true; return "First name can't be empty."; }, renderObject: Field},
    lastname: { title: "Last name", changed: false, editComponent: TextFieldEdit, renderObject: Field},
    address: { title: "Address", changed: false, editComponent: TextFieldEdit, renderObject: Field},
    zip: { title: "Zip code", changed: false, editComponent: TextFieldEdit, renderObject: Field},
    city: { title: "City", changed: false, editComponent: TextFieldEdit, renderObject: Field},
    state: { title: "State / Province", changed: false, editComponent: TextFieldEdit, renderObject: Field},
    country: {title: 'Country', renderObject: CountryDropDown, changed: false, editComponent: null},

    dob_year: { title: "DOB Year", changed: false, editComponent: TextFieldEdit, validator: function(value) {if(value.match(/^[0-9]{4}$/)) return true; return "YYYY"; } , renderObject: Field},
    dob_month: { title: "DOB Month", changed: false, editComponent: TextFieldEdit, validator: function(value) {if(value.match(/^([1-9]|1[012])$/)) return true; return "MM"; } , renderObject: Field},
    dob_day: { title: "DOB Day", changed: false, editComponent: TextFieldEdit, validator: function(value) {if(value.match(/^(0?[1-9]|[12][0-9]|3[01])$/)) return true; return "DD"; } , renderObject: Field},

    email: { title: "Email", changed: false, editComponent: TextFieldEdit, validator: function(value) {if(value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) return true; return "Not valid email";}, renderObject: Field},
    url: { title: "Website", changed: false, editComponent: TextFieldEdit, renderObject: Field},
    phoneprefix: { title: "Country Code", changed: false, editComponent: TextFieldEdit, validator: function(value) {if(value.match(/^(\+)[0-9]{1,4}$/)) return true; return "prefix with + max 4 digits"; }, renderObject: Field },
    phone: { title: "Primary Phone", changed: false, editComponent: TextFieldEdit, validator: function(value) {if(value.match(/^[0-9\s]+$/)) return true; return "only digits and spaces"; }, renderObject: Field },
    mobile: { title: "Secondary Phone", changed: false, editComponent: TextFieldEdit, validator: function(value) {if(value.match(/^[0-9\s]+$/)) return true; return "only digits and spaces"; }, renderObject: Field },
    euvatid: { title: "VAT Id", changed: false, editComponent: TextFieldEdit, validator: function(value) {if(value.match(/^[0-9\s]+$/)) return true; return "only digits and spaces"; }, renderObject: Field},
    economic_creditor_id: { title: "Economic Creditor ID", changed: false, editComponent: TextFieldEdit, renderObject: Field},
    company: { title: "Company", changed: false, editComponent: TextFieldEdit, renderObject: Field},
    timezone: {title: 'Timezone', renderObject: TimezoneDropDown, changed: false, editComponent: null}
  }

  getFields(attributes) {
    return _.map(attributes, (value, name) => ({
      value,
      orignalValue: value,
      name,
      ...this.fieldDefaults[name],
    }));
  }

  handleSave = (field, cancel=false) => {
    if(cancel) {
      this.setState({fields: this.state.fields.map((field) => {
        field['value'] = field['originalValue'];
        field['changed'] = false;
        return field;
      })});

    } else {
      const { supplier: { uid: supplierId } } = this.props;
      const data = _.reduce(this.state.fields, (fields, field) => { fields[field['name']] = field['value']; return fields; }, {});
      if (typeof data.country == 'array') {
        data.country = 0;
      } else {
        data.country = data.country.uid || data.country || 0;
      }
      actions.saveSupplier(supplierId, data);
      SupplierLogger.log(supplierId, 'Contact information was updated');
      this.setSaved();
    }
  }

  setSaved() {
    this.setState({saved: true});
    setTimeout(this.unsetSaved, 2000);
  }

  unsetSaved = () => {
    this.setState({saved: false});
  }

  fieldValueChanged = (fieldName, evt) => {
    this.setState({fields: this.state.fields.map((field) => {
      if(field['name'] == fieldName) {
        field['value'] = evt.currentTarget.value;
        if(field['value']!=field['orignalValue']) {
          field['changed'] = true;
        } else {
          field['changed'] = false;
        }
      }
      return field;
    })});
  }

  render() {
    return (
      <Panel>
        <Header onSave={this.handleSave} title="Contact Data" saved={this.state.saved} />
        <PanelBody>
          <Table margin="0">
            <TableBody>
              {this.state.fields.map((field) => (
                <field.renderObject
                  key={field.name}
                  onChange={(event) => this.fieldValueChanged(field['name'], event)}
                  handleSave={this.handleSave}
                  editComponent={field['editComponent']}
                  title={field['title']}
                  value={field['value']}
                  name={field.name}
                  changed={field.changed}
                  validator={field.validator}
                />
              ))}
            </TableBody>
          </Table>
        </PanelBody>
      </Panel>
    );
  }
}

export { ContactWidget };
